// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"f2dbd66a","152":"42b79e61","345":"229b1f7c","504":"61215c24","518":"4060d175","594":"2c2f4c59","894":"26811dc5"}[chunkId] + ".chunk.js";
};